import { useEffect } from 'react';

import passportInstance from '../lib/immutable/passport';
import { isLocal } from '../constants/envs';


// Store the url params, since they are lost already when the hook triggers
const initialSearch = window.location.search;
if (initialSearch) {
  sessionStorage.setItem('imx_oauth_search', initialSearch);
}

export default function AuthCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      isLocal && console.log('[imx] start');
      try {
        // Log the URL immediately before calling loginCallback
        isLocal && console.log('[imx] URL before loginCallback:', window.location.href);
        const savedSearch = sessionStorage.getItem('imx_oauth_search');
        if (savedSearch) {
          window.history.replaceState({}, '', `${window.location.pathname}${savedSearch}`);
          sessionStorage.removeItem('imx_oauth_search');
        }
        await passportInstance.loginCallback();
      } catch (error) {
        console.error('Auth callback failed:', error);
        alert('imxt auth failed - caught error. Check console.');
      }
    };
    handleCallback();
  }, []);

  return <div>Authenticating...</div>;
}